import { render, staticRenderFns } from "./NewRfqDropZone.vue?vue&type=template&id=3fbd1733&"
import script from "./NewRfqDropZone.vue?vue&type=script&lang=js&"
export * from "./NewRfqDropZone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports